// MapModal.js
import React, { useState } from "react";
import { Modal } from "antd";
import { GoogleMap, Marker, useLoadScript,Circle, InfoWindow } from "@react-google-maps/api";
import { statusIcons } from "../../utils/statusIcons";

const mapContainerStyle = {
  height: "400px",
  width: "100%"
};

const redMarkerIcon = "http://maps.google.com/mapfiles/ms/icons/red-dot.png";

const MapModal = ({ visible, onClose, location, place }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  });
  // const [activeMarker, setActiveMarker] = useState(null);

  if (loadError) return <div>Error loading map</div>;

   //function to handle marker infoWindow
  //  const handleActiveMarker = (marker) => {
  //   if (marker === activeMarker) return;
  //   setActiveMarker(marker);
  // };
  return (
    <Modal
      title={`Map - ${place}`}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={location}
          zoom={7}
        >
          {/* <Marker position={location} /> */}
          <Marker
            position={{
              lat: location?.lat,
              lng: location?.lng,
            }}
           icon={{
              url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png", 
              // scaledSize: new window.google.maps.Size(30, 50)
              scaledSize: new window.google.maps.Size(
                 10,
                20
              ),
            }}
          />
        </GoogleMap>
      )}
    </Modal>
  );
};

export default MapModal;


// import React, { useEffect, useRef } from "react";
// import { Modal } from "antd";

// const MapModal = ({ visible, onClose, location, place }) => {
//   const mapRef = useRef(null);
//   useEffect(() => {
//     if (visible && window.google && mapRef.current) {
//       const map = new window.google.maps.Map(mapRef.current, {
//         center: location,
//         zoom: 8,
//       });

//       const marker = new window.google.maps.Marker({
//         position: location,
//         map,
//         title: place,
//         icon: {
//           url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png", 
//         },
//       });
//     }
//   }, [visible, location, place]);

//   return (
//     <Modal
//       title={`Map - ${place}`}
//       open={visible}
//       onCancel={onClose}
//       footer={null}
//       width={600}
//     >
//       <div
//         ref={mapRef}
//         style={{ width: "100%", height: "400px" }}
//         id="map-canvas"
//       />
//     </Modal>
//   );
// };

// export default MapModal;
